// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ element: Component }) => {
    // const { isAuthenticated } = useAuth();
const isAuthenticated = true;
    return isAuthenticated ? <Component /> : <Navigate to="/" />;
};

export default PrivateRoute;
